// extracted by mini-css-extract-plugin
module.exports = {"contentBankListCards":"style_contentBankListCards__rk8Pn","loading":"style_loading__Igh6W","containerBankList":"style_containerBankList__NqaPj"};